// Dependecies
import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

function Reload({ number, text, title, img, firstTxt, secondTxt, link, linkTxt }) {
  if (number !== 0) {
    return (
      <div className="spinner-main">
        <div className="spinner-second">
          <div className="spinner"> </div>
          <p className="">{text}</p>
        </div>
      </div>
    );
  }
  return (
    <>
      <div className="content_dynamic history block-job-requests">
        <div className="row content_maintenace">
          <div className="header-content">
            <div className="info-tittle">
              <h1 className="title-maintenances">{title}</h1>
            </div>
          </div>
        </div>
        <div className="not-services">
          <img src={img} className="img-not-maintenances" alt="" />
          <div>
            <h4 className="center txt-20 first-txt">{firstTxt}</h4>
          </div>
          <div>
            <p className="center second-txt">{secondTxt || ''}</p>
          </div>
          <div>
            {link !== '' ? (
              <a href={link}>
                <p className="center link">{linkTxt || ''}</p>
              </a>
            ) : (
              ''
            )}
          </div>
        </div>
      </div>
    </>
  );
}

Reload.propTypes = {
  number: PropTypes.number,
  text: PropTypes.string,
  title: PropTypes.string,
  img: PropTypes.string,
  firstTxt: PropTypes.string,
  secondTxt: PropTypes.string,
  link: PropTypes.string,
  linkTxt: PropTypes.string,
};

Reload.defaultProps = {
  number: 0,
  text: '',
  title: '',
  img: '',
  firstTxt: '',
  secondTxt: '',
  link: '',
  linkTxt: '',
};

export default withTranslation('alt')(Reload);
